module.exports = __webpack_public_path__ + "static/media/dog.d8af14d7.png";